import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProjectManagement from './pages/project-management';
import AdminDashboard from './pages/admin-dashboard';
import Login from './pages/login';
import ClientPortal from './pages/client-portal';
import TechnicianMobile from './pages/technician-mobile';
import ServiceOrders from './pages/service-orders';
import DemandManagement from './pages/demand-management';
import PerformanceAnalytics from './pages/performance-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/client-portal" element={<ClientPortal />} />
        <Route path="/technician-mobile" element={<TechnicianMobile />} />
        <Route path="/service-orders" element={<ServiceOrders />} />
        <Route path="/demand-management" element={<DemandManagement />} />
        <Route path="/performance-analytics" element={<PerformanceAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;